export const REQUEST_CANCELED_ERROR = "REQUEST_CANCELED_BY_USER";
